import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { useSelector } from "react-redux";

import { RootState } from "src/state/reducers";

export const Routes = {
    about: "/about",
    account: "/account",
    admin: {
        createSchool: "/admin/create-school",
        createReport: "/admin/create-report",
        createUser: "/admin/create-user",
        editSchool: "/admin/edit-school",
    },
    auth: "/auth",
    constituentGroups: "/constituents",
    dashboard: "/",
    noop: "#",
    promotion: "/promotion",
    // TODO: Refactor all usages of the report route object
    report: {
        home: "/reports",
        expertiseAndResources: "/report/expertise-and-resources",
        full: "/report",
        fullMultiple: "/reports-temp",
        learningOrientation: "/report/learning-orientation",
        teachingAndLearning: "/report/teaching-and-learning",
        overview: "/reports/:type/:year/overview",
        purpose: "/report/purpose",
        relationships: "/report/relationships",
        strengthAndGrowthOpportunities: "/report/strength-and-growth-opportunities",
        wellBeing: "/report/well-being",
        intellectual: "/report/intellectual",
        nurture: "/report/nurture",
        practical: "/report/practical",
        head: "/report/head",
        hands: "/report/hands",
        heart: "/report/heart",
    },
    section: {
        expertiseAndResources: "expertise-and-resources",
        learningOrientation: "learning-orientation",
        teachingAndLearning: "teaching-and-learning",
        overview: "overview",
        purpose: "purpose",
        relationships: "relationships",
        strengthAndGrowthOpportunities: "strength-and-growth-opportunities",
        wellBeing: "well-being",
        intellectual: "intellectual",
        nurture: "nurture",
        practical: "practical",
        head: "head",
        hands: "hands",
        heart: "heart",
    },
} as const;

/*
 * Component
 */

export const ProtectedRoute = (props: RouteProps): React.ReactElement => {
    const { component: Component, ...rest } = props;
    const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);

    if (!Component) return <></>;

    return (
        <Route
            {...rest}
            render={(props) => {
                return isLoggedIn ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: Routes.auth,
                            state: { from: props.location },
                        }}
                    />
                );
            }}
        />
    );
};
